import { useSignedCdnImage } from './chunk-3JVPQKNG.js';
import { Badge } from './chunk-2WDEGOCV.js';
import { cn } from './chunk-FFX3LZW7.js';
import { networkKindLabel, networkKindDescription, subscribeChainRegistry, chainRegistryVersion, getChainMetadata, chainMonogram } from '@authe/fe-commons/chains';
import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { Laptop, Blocks } from 'lucide-react';

function NetworkKindBadge({
  kind,
  className
}) {
  const label = networkKindLabel(kind);
  if (!label) return null;
  return /* @__PURE__ */ jsx(Badge, { variant: "info", className: cn("text-3xs", className), title: networkKindDescription(kind), children: label });
}
function useChainRegistryVersion() {
  return React.useSyncExternalStore(subscribeChainRegistry, chainRegistryVersion, chainRegistryVersion);
}
var SIZES = {
  sm: { box: "size-4 text-3xs", text: "text-xs" },
  md: { box: "size-6 text-xs", text: "text-sm" },
  lg: { box: "size-8 text-sm", text: "text-base" }
};
function ChainAvatar({
  chain,
  size = "md",
  showName = true,
  note,
  nativeTitle = true,
  logoUrl,
  logoResolver,
  className
}) {
  useChainRegistryVersion();
  const resolved = getChainMetadata(chain);
  const name = resolved?.name ?? chain;
  const kindLabel = networkKindLabel(resolved?.networkKind);
  const described = [name, kindLabel && `${kindLabel.toLowerCase()} network`, note].filter(Boolean).join(" \u2014 ");
  const initials = chainMonogram(resolved, chain);
  const sz = SIZES[size];
  const candidate = logoUrl ?? logoResolver?.(chain, resolved?.slug) ?? resolved?.logoUrl ?? void 0;
  const image = useSignedCdnImage(candidate);
  const NetworkIcon = resolved?.networkKind === "local" ? Laptop : resolved?.networkKind === "private" ? Blocks : null;
  const brand = resolved?.brandColor ?? void 0;
  const [failedSrc, setFailedSrc] = React.useState(null);
  const logo = image.src && image.src !== failedSrc ? image.src : void 0;
  return /* @__PURE__ */ jsxs(
    "span",
    {
      className: cn("inline-flex items-center gap-2", className),
      title: nativeTitle ? described : void 0,
      children: [
        logo ? /* @__PURE__ */ jsx(
          "img",
          {
            src: logo,
            crossOrigin: image.crossOrigin,
            alt: "",
            "aria-hidden": true,
            className: cn("rounded-full object-cover", sz.box),
            onError: () => setFailedSrc(logo)
          }
        ) : /* @__PURE__ */ jsx(
          "span",
          {
            "aria-hidden": true,
            className: cn(
              "inline-flex items-center justify-center rounded-full font-semibold",
              !brand && "bg-muted text-muted-foreground",
              sz.box
            ),
            style: brand ? { backgroundColor: `${brand}22`, color: brand } : void 0,
            children: NetworkIcon ? /* @__PURE__ */ jsx(NetworkIcon, { className: "size-full p-0.5", "aria-hidden": true }) : initials
          }
        ),
        showName === true && /* @__PURE__ */ jsxs("span", { className: cn("font-medium", sz.text), children: [
          name,
          note && /* @__PURE__ */ jsxs("span", { className: "sr-only", children: [
            " \u2014 ",
            note
          ] })
        ] }),
        showName === true && /* @__PURE__ */ jsx(NetworkKindBadge, { kind: resolved?.networkKind }),
        showName === "sr-only" && /* @__PURE__ */ jsx("span", { className: "sr-only", children: described })
      ]
    }
  );
}

export { ChainAvatar, NetworkKindBadge, useChainRegistryVersion };
//# sourceMappingURL=chunk-UHTGLWOP.js.map
//# sourceMappingURL=chunk-UHTGLWOP.js.map